import React, { useState } from 'react'
import Toggle from 'builder/components/Toggle'
import { useI18n } from 'builder/hooks/useI18n'
import { ToggleProps } from 'builder/components/Toggle/Toggle'
import * as Styles from './styles'

type Ref = React.ForwardedRef<HTMLInputElement | null>
type Props = {
  image: React.ReactNode
  titleText: string
  subtitleText: string
  toggleText: string
  onToggle: (value: boolean) => void
} & ToggleProps

const TRANSLATION = 'builder.auto_apply.form'

export const TailoringToggleCard = React.forwardRef(
  ({ onToggle, image, titleText, subtitleText, toggleText, ...rest }: Props, ref: Ref) => {
    const [checked, setChecked] = useState(rest.checked)
    const { i18n } = useI18n()

    const onClickCard = (e: React.MouseEvent<HTMLDivElement>) => {
      e.preventDefault()
      onToggle(!checked)
      setChecked(!checked)
    }

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onToggle(e.target.checked)
      setChecked(e.target.checked)
    }

    return (
      <Styles.Container onClick={onClickCard}>
        <Styles.InfoContainer>
          <Styles.IconContainer>{image}</Styles.IconContainer>
          <Styles.TextContainer key={`text_${checked?.toString()}`}>
            <Styles.Header>{titleText}</Styles.Header>
            <Styles.Description>{subtitleText}</Styles.Description>
          </Styles.TextContainer>
        </Styles.InfoContainer>
        <Styles.SecondLine>
          <Styles.SecondLineTextContainer>
            <Styles.ResumeTailoringText>
              {toggleText}
              <Styles.WrapperToggle>
                <Toggle ref={ref} {...rest} checked={checked} onChange={onChange} />
              </Styles.WrapperToggle>
            </Styles.ResumeTailoringText>

            <Styles.Status>
              {i18n.t(`${TRANSLATION}${checked ? '.enabled' : '.disabled'}`)}
              <Styles.StatusIcon $enabled={!!checked} />
            </Styles.Status>
          </Styles.SecondLineTextContainer>
        </Styles.SecondLine>
      </Styles.Container>
    )
  },
)
